import React, { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

import { BaseFont } from 'src/styles/font';
import { mixpanelObject } from 'src/utils/analytics';
import { aggregatorPropertySetter } from 'src/utils/analytics/mixpanel/propertySetter';
import { DynamicObject } from 'src/utils/commonTypes';

import * as customStyled from './styles';
import { toastMessageImpression } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { MIXPANEL_TOAST_MESSAGE } from '../../utils/analytics/mixpanel/mixpanelConstants';

interface ToastMessageProps {
  duration?: number;
  container?: any;
  textColor?: string;
  backgroundColor?: string;
  message: string;
  mixpanelMessage?: string;
  contentPartnerDetails?: DynamicObject;
  width?: string;
  textAlign?: string;
  margin?: string;
  maxWidth?: string;
  padding?: string;
  fontSize?: number;
  lineHeight?: number;
  fontWeight?: number;
  fontFamily?: string;
}

const ToastMessage: React.FC<ToastMessageProps> = ({
  duration: userDefinedDuration,
  container,
  backgroundColor,
  textColor,
  message,
  mixpanelMessage,
  contentPartnerDetails,
  width,
  margin,
  textAlign,
  maxWidth,
  padding,
  fontSize,
  lineHeight,
  fontWeight,
  fontFamily
}) => {
  const [duration, changeDuration] = useState(userDefinedDuration || 2000);
  const [isClientSide, setIsClientSide] = useState(false);
  let portalContainer = document.getElementById('modal-root');
  if (isClientSide) {
    if (container) {
      const customContainer = document.getElementById(container);
      if (customContainer) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        portalContainer = customContainer;
      }
    }
  }
  const userDefinedStyles: DynamicObject = {};
  if (backgroundColor) {
    userDefinedStyles.backgroundColor = backgroundColor;
    userDefinedStyles.border = 'none';
  }
  if (textAlign) {
    userDefinedStyles.textAlign = textAlign;
  }
  if (textColor) {
    userDefinedStyles.textColor = textColor;
  }
  if (width) {
    userDefinedStyles.width = width;
  }
  if (margin) {
    userDefinedStyles.margin = margin;
  }
  if (maxWidth) {
    userDefinedStyles.maxWidth = maxWidth;
  }
  if (padding) {
    userDefinedStyles.padding = padding;
  }
  if (fontFamily && fontSize && lineHeight && fontWeight) {
    userDefinedStyles['font-family'] = fontFamily;
    userDefinedStyles['font-weight'] = fontWeight;
    userDefinedStyles['font-size'] = `${fontSize / BaseFont}rem`;
    userDefinedStyles['line-height'] = `${lineHeight / BaseFont}rem`;
  }
  const toastMixpanelEvent = () => {
    if (contentPartnerDetails) {
      aggregatorPropertySetter(contentPartnerDetails);
    }
    mixpanelObject.setProperty(
      MIXPANEL_TOAST_MESSAGE,
      mixpanelMessage || message
    );
    toastMessageImpression();
  };

  // Use Effect hooks
  useEffect(() => {
    setIsClientSide(true);
  }, []);

  useEffect(() => {
    if (isClientSide) {
      toastMixpanelEvent();
    }
  }, [isClientSide]);

  useEffect(() => {
    const timeout =
      duration !== 0
        ? setTimeout(() => {
            changeDuration(0);
          }, duration)
        : 0;

    return () => {
      clearTimeout(timeout);
    };
  }, [duration]);

  const portal = duration ? (
    <div css={customStyled.toastContainer}>
      <div
        css={customStyled.toastMessage}
        style={{
          ...userDefinedStyles
        }}>
        {message}
      </div>
    </div>
  ) : null;
  if (!isClientSide) return null;
  return createPortal(portal, portalContainer as Element | DocumentFragment);
};

export default ToastMessage;
